import { render, staticRenderFns } from "./commonSettingNoticeDetail.vue?vue&type=template&id=e2f48b5a&scoped=true"
import script from "./commonSettingNoticeDetail.vue?vue&type=script&lang=js"
export * from "./commonSettingNoticeDetail.vue?vue&type=script&lang=js"
import style0 from "./commonSettingNoticeDetail.vue?vue&type=style&index=0&id=e2f48b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f48b5a",
  null
  
)

export default component.exports